export { default } from './CorporateGroupDetailsPage'